<template>
    <div style="height:100vh" class="flex x-left flex-column">
        <div v-if="is_self_current" class="header-box">
            <custom-header2 @exportSeat="handleExportSeatEvent"></custom-header2>
        </div>
        <div class="layout-wrapper" style="overflow:hidden;">
            <div ref="previewWrapper"  :style="`width: ${draggableBoxWidth}px;`" :class="($route.query.person_id || $route.query.search_name) ?'search-mode-style':''">
                <div class="dancebool" :style="`width: ${draggableBoxWidth}px;`">
                    <span v-for="item in Math.floor(draggableBoxWidth / 120)" :key="item">舞台区域</span>
                </div>
                <div class="draggable-box" ref="draggableBox" :style="`width: ${draggableBoxWidth}px;height: ${draggableBoxHeight}px;`">
                    <div class="draggable-item-root" v-for="(item,index) in layoutData" :key="item.area_id" :style="`width: ${draggableBoxWidth}px;`+setStyleFun(item.area_style)">
                        <!-- 剧院 -->
                        <d-juyuan style="display:inline-block;" :isPreview="true" :layout-index="index" :ref="'layout'+index" :curr-layout-data="item" v-if="item.desk_type && item.desk_type.type == 'd_juyuan'"></d-juyuan>
                        <!-- 圆 -->
                        <d-yuan style="display:inline-block;" :isPreview="true" :layout-index="index" :ref="'layout'+index" :curr-layout-data="item" v-if="item.desk_type && item.desk_type.type == 'd_yuan'"></d-yuan>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!show_gesture_tip" class="gesture-tip">
            <div class="gesture-icon t-c">
                <img src="~@/assets/images/gesture-icon.png" alt="">
                <p>可根据手势或者鼠标滚轮实现缩放</p>
                <a-button @click="handleCloseTipEvent">确定</a-button>
            </div>
        </div>
        <a-button v-if="!is_self_current" @click="handleFullscreenEvent" class="fullscreen-btn">{{ !isFullscreen ? '全屏查看' : '取消全屏'}}</a-button>
        <div class="qrcode-box t-c" v-if="is_self_current && show_qrcode">
            <div id="qrcode"></div>
            <div class="mt10">扫一扫查找座位</div>
            <div @click="show_qrcode = false" class="qrcode-jiao flex x-center y-center">
                <a-icon type="close" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import dJuyuan from '@/components/seat-type/d_juyuan.vue';
import dYuan from '@/components/seat-type/d_yuan.vue';
import customHeader2 from '@/components/layout/custom-head2.vue';
import { EasyScroller } from 'easyscroller'
import QRCode from "qrcodejs2";
import html2canvas from 'html2canvas';
export default {
    name: "Preview",
    components: { customHeader2, dJuyuan, dYuan },
    props: {

    },
    data() {
        return {
            isFullscreen:false,     // 是否全屏观看  
            draggableBoxWidth: 0,   // 拖动区域宽度
            draggableBoxHeight: 0,  // 拖动区域高度
            is_self_current:false,  // 是否被iframe嵌套 默认false
            show_gesture_tip:true,  // 是否显示过提示层
            show_qrcode : true,     // 是否显示二维码
        }
    },
    computed: {
        ...mapState(['layoutData']),
    },
    methods: {

        // 导出座位
        handleExportSeatEvent(){
            const ref = this.$refs.previewWrapper;
            ref.style.transform = 'scale(1)';
            html2canvas(ref,{
                useCORS:true,
                // 允许加载跨域的图片
                allowTaint: true,
                // 检测每张图片都已经加载完成
                tainttest: true,
                // 添加的scale 参数
                scale: 3,
            }).then(canvas => {
                const dataURL = canvas.toDataURL('image/png')
                const creatDom = document.createElement('a')
                document.body.appendChild(creatDom)
                creatDom.href = dataURL
                creatDom.download = '座位分布图'
                creatDom.click()
            })
        },

        // 全屏
        handleFullscreenEvent(){
            this.isFullscreen = !this.isFullscreen;
            let iframe = window.parent.document.getElementsByTagName('iframe')[0];
            if(this.isFullscreen){
                iframe.classList.add("iframe-fullscreen");
            }else{
                iframe.classList.remove("iframe-fullscreen");
            }
            // 刷新iframe
            let href = window.location.origin;
            let hash = window.location.hash;
            iframe.src = `${href}/?time=${+(new Date())}${hash}`;
        },

        // 创建二维码
        createQrcode() {
            let params = this.$route.params;
            let winHref = window.location.href.split('#')[0];
            let url = `${winHref}#/searchseat/${params.meeting_id}`;
            var qrcode = new QRCode("qrcode", {
                width:120,
                height:120,
                text: url, //表示内容，可以是地址或者是文字'55566'或者参数
                colorDark: "#000000", //前景色
                colorLight: "#ffffff", //背景色
                correctLevel: QRCode.CorrectLevel.H //容错级别
            })
        },


        // 关闭提示层
        handleCloseTipEvent(){
            this.show_gesture_tip = true;
            this.$storage.set("show_gesture_tip",true)
        },

        // 缩放初始化
        scaleInit(){
            let winWidth = window.innerWidth;
            let winHeight = window.innerHeight;
            let heightScale = winHeight / this.draggableBoxHeight;
            let widthScale = winWidth / this.draggableBoxWidth;
            // 盒子宽高与window宽高比 那侧最大用那侧(目的在可视窗口内显示全)
            let zoomLevel = widthScale < heightScale ? widthScale : heightScale;
            zoomLevel = zoomLevel > 1 ? 1 : zoomLevel;
            new EasyScroller(this.$refs.previewWrapper, {
                scrollingX: true,
                scrollingY: true,
                zooming: true,
                minZoom: zoomLevel > 0.1 ? 0.1 : zoomLevel,
                maxZoom: 3.0,
                zoomLevel
            });
        },

        setStyleFun(area_style){
            return `position:relative;left:${area_style.left};top:${area_style.top};`
        },
       
        // 更新拖动
        setDraggableAreaSize() {
            const draggableBox = this.$refs['draggableBox'] || {};
            //const offsetWidth = draggableBox.offsetWidth || 0;
            let scrollWidth = draggableBox.scrollWidth || 0;
            let winWidth = window.innerWidth;
            scrollWidth = scrollWidth > winWidth ? scrollWidth : winWidth;
            //scrollWidth = (offsetWidth <= scrollWidth) ? scrollWidth : (scrollWidth + 100);
            // 需要设置滚动区域width值，拖动才能生效
            this.draggableBoxWidth = scrollWidth;
            this.draggableBoxHeight =  draggableBox.scrollHeight + 250 || 0;
        },
        // 获取布局
        getLayoutData() {
            this.$store.dispatch('getLayoutData', { hall_id: this.$route.query.hall_id }).then(res => {
                this.$nextTick(() => {
                    // 页面渲染完成后获取真实dom尺寸并赋值。
                    this.setDraggableAreaSize();
                    this.scaleInit();
                })
            });
        }
    },
    mounted() {
        if(self == top){
            this.is_self_current = true;
            this.$nextTick(() => {
                this.createQrcode();
            })
        }
        // 是否目前是否全屏
        let iframe = window.parent.document.getElementsByTagName('iframe')[0];
        this.isFullscreen = iframe?.classList?.value.indexOf('iframe-fullscreen') != -1 ? true : false;

        // 是否显示缩放提示
        this.show_gesture_tip = this.$storage.get("show_gesture_tip");
        this.getLayoutData();
    },
}
</script>

<style lang="less" scoped>
@import url('~@/assets/css/layout-style.less');
@import url('~@/assets/css/search-mode-style.less');
.draggable-box{
    position: relative;
        &:after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999;
    }
}
.draggable-item-root{
    padding-top:32px;
}
.fullscreen-btn{
    position: fixed;
    right:10px;
    top:10px;
    transform: scale(0.8);
    z-index: 3;
}
.gesture-tip{
    position: fixed;
    left:0;
    top:0;
    width: 100%;
    height:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background:rgba(0,0,0,0.3);
    .gesture-icon{
        img{
            width:200px;
            margin:0 auto;
        }
        p{
            font-size:24px;
            font-weight: bold;
            margin-top:30px;
            color:#fff;
        }
    }
}

.qrcode-box{
    position: fixed;
    right:3px;
    top:20%;
    padding:15px;
    background-color: #fff;
    box-shadow: 0px 1px 10px 0px rgba(29, 154, 170, 0.18);
    .qrcode-jiao{
        position: absolute;
        top:-25px;
        right:0;
        cursor: pointer;
        width: 25px;
        height:25px;
        background-color: #fff;
        box-shadow: 0px -3px 5px rgba(29, 154, 170, 0.18);
    }
}

@media screen and (max-width:768px) {
.gesture-tip{
    .gesture-icon{
        img{
            width:80px;
        }
        p{
            font-size:14px;
        }
    }
}
}
</style>